module.exports = __webpack_public_path__ + "img/se-summer-desktop.e35ab4d4.png";